module.exports = __webpack_public_path__ + "static/image-1-2367e6ff0b7f7cb51b2b66de8196289b.jpg";